import { render, staticRenderFns } from "./Stylists.vue?vue&type=template&id=1210e238&scoped=true&"
import script from "./Stylists.vue?vue&type=script&lang=js&"
export * from "./Stylists.vue?vue&type=script&lang=js&"
import style0 from "./Stylists.vue?vue&type=style&index=0&id=1210e238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210e238",
  null
  
)

export default component.exports